import React, { ReactElement } from 'react';
import { useSelector } from 'react-redux';

import { getElementId } from '../../../../../../common/elements/utils/elementPropertyUtils';
import { selectSelectedElementsOrInnerTask } from '../../../selector/selectionToolsSelector';
import useSheet from '../../../../../mobile/structural/sheet/hooks/useSheet';

// Components
import Icon from '../../../../../components/icons/Icon';
import ToolbarTool from '../../ToolbarTool';
import MobileReactionsSheet from '../../../../../element/reactions/popup/MobileReactionsSheet';

// Types
import { SheetId } from '../../../../../mobile/structural/sheet/sheetTypes';
import { useGroupTranslator } from '../../../../../components/i18n/GroupTranslationContext';

type MobileReactionToolProps = {
    name: string;
    gridSize: number;
};

const MobileReactionTool = (props: MobileReactionToolProps): ReactElement => {
    const { gridSize } = props;
    const translate = useGroupTranslator();
    const mobileName = translate('mobile.reaction');

    const elements = useSelector(selectSelectedElementsOrInnerTask);
    const elementIds = elements.map(getElementId).toArray();

    const sheetProps = useSheet(SheetId.ReactionTool, elementIds[0]);
    const { isSheetOpen, dispatchOpenSheet, dispatchCloseSheet } = sheetProps;

    return (
        <>
            <ToolbarTool name={mobileName} isOpen={isSheetOpen} onClick={dispatchOpenSheet}>
                <Icon gridSize={gridSize} name={`toolbar-reaction`} />
            </ToolbarTool>
            <MobileReactionsSheet
                gridSize={gridSize}
                sheetProps={sheetProps}
                closePopup={dispatchCloseSheet}
                elementIds={elementIds}
            />
        </>
    );
};

export default MobileReactionTool;
